import { createFileRoute, redirect } from "@tanstack/react-router";

import {
  coachContentHubQueryOptions,
  contentHubItemQueryOptions,
} from "src/components/contentHubQueries";
import { ContentHubFolderPage } from "src/pages/ContentHubFolderPage";
import { ContentHubTabPage } from "src/pages/ContentHubTabPage";

export const Route = createFileRoute(
  "/_auth/_coach/content-hub/$contentHubId/$",
)({
  component: RouteComponent,
  ssr: true,
  async loader(props) {
    const segments = (props.params._splat ?? "").split("/").filter(Boolean);

    if (segments.length === 0) {
      throw redirect({
        to: "/content-hub/$contentHubId",
        params: { contentHubId: props.params.contentHubId },
      });
    }

    const tabId = segments[0];

    const contentHub = await props.context.queryClient.query({
      ...coachContentHubQueryOptions(props.params.contentHubId, tabId),
      staleTime: "static",
    });

    const tab = contentHub.tabs.find((candidate) => {
      return candidate.id === tabId;
    });

    if (!tab) {
      throw redirect({
        to: "/content-hub/$contentHubId",
        params: { contentHubId: props.params.contentHubId },
      });
    }

    const breadcrumbs = [
      {
        id: contentHub.id,
        label: contentHub.title,
        href: `/content-hub/${contentHub.id}`,
      },
    ];

    if (segments.length >= 2) {
      const folderId = segments[1];
      const folder = await props.context.queryClient.query({
        ...contentHubItemQueryOptions(folderId),
        staleTime: "static",
      });

      breadcrumbs.push({
        id: folder.id,
        label: folder.title ?? "Untitled",
        href: `/content-hub/${props.params.contentHubId}/${tabId}/${folder.id}`,
      });
    }

    return { breadcrumb: breadcrumbs };
  },
});

function RouteComponent() {
  const params = Route.useParams();
  const segments = (params._splat ?? "").split("/").filter(Boolean);
  const tabId = segments[0];
  const folderId = segments[1];

  if (folderId) {
    return (
      <ContentHubFolderPage
        contentHubId={params.contentHubId}
        tabId={tabId}
        folderId={folderId}
      />
    );
  }

  return <ContentHubTabPage contentHubId={params.contentHubId} tabId={tabId} />;
}
